// src/components/Sidebar.jsx
import { Link, NavLink } from 'react-router-dom';
import { HomeIcon,CurrencyDollarIcon ,KeyIcon,BellAlertIcon ,TicketIcon, UserIcon,CogIcon ,ChatBubbleBottomCenterIcon, ClipboardDocumentListIcon  } from '@heroicons/react/24/outline';
import { logo } from '../assets/Images';
import { useState } from 'react';
import SupportTicketModal from './SupportTicketModal';
import { useReduxStore } from '../hooks/useReduxStore';
import { ImageUrl } from '../services/API';
import { glass } from '../styles/glass';

const menuItems = [
  { name: 'Dashboard', path: '/Admin/Dashboard',
     icon: <HomeIcon className='h-6 w-6' />
     },
  { name: 'Users', path: '/Admin/Dashboard/Users', 
    icon: <UserIcon className='h-6 w-6' />
   },
  { name: 'Subscriptions', path: '/Admin/Dashboard/Subscription', 
    icon: <CurrencyDollarIcon  className='h-6 w-6' />
   },
  { name: 'API Keys', path: '/Admin/Dashboard/APIKeys', icon: <KeyIcon  className='h-6 w-6' /> },
  { name: 'Bulletin Board', path: '/Admin/Dashboard/BulletinBoard', icon: <ClipboardDocumentListIcon className='h-6 w-6' /> },
  { name: 'Alerts', path: '/Admin/Dashboard/Alerts', icon: <BellAlertIcon  className='h-6 w-6' /> },
  { name: 'Chat', path: '/Admin/Dashboard/Chat', icon: <ChatBubbleBottomCenterIcon  className='h-6 w-6' /> },
  { name: 'Settings', path: '/Admin/Dashboard/Settings', icon: <CogIcon  className='h-6 w-6' /> },
  { name: 'Support', path: '/Admin/Dashboard/Support', icon: <TicketIcon  className='h-6 w-6' /> },
];

export default function AdminSidebar({ collapsed, mobileOpen = false, onCloseMobile }) {
  const {getState}=useReduxStore()
  const {settings}=getState("AUTH")
  const [showSupportModal, setShowSupportModal] = useState(false);
// console.log("settings",settings)
  const handleSupportClick = (e) => {
    e.preventDefault();
    setShowSupportModal(true);
  };

  const isMobileOverlay = !!mobileOpen;

  return (
    <>
      {/* Mobile overlay backdrop */}
      {isMobileOverlay && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={onCloseMobile}
        />
      )}

      <div className={`
        ${isMobileOverlay ? 'fixed left-0 top-0 h-screen z-50 lg:relative lg:z-auto' : 'lg:relative'}
        ${mobileOpen ? 'block' : 'hidden'} lg:block
        h-full ${glass} px-3 text-white transition-all duration-300 ${collapsed ? 'w-24' : 'w-[16rem]'} overflow-hidden
      `}>
        <div className="border-b border-borderGray p-4 pb-8 pt-6 text-center font-bold text-xl">
         <Link to={"/Admin/Dashboard"}>
          <img  src={settings?.brandLogo?`${ImageUrl}${settings?.brandLogo}`:logo} className={`${collapsed?"h-8":"h-24"} ${collapsed?"w-8":"w-24"} mx-auto object-contain object-center `}/></Link>
        </div>
        <nav className="mt-4 flex flex-col gap-2 px-2">
          {menuItems.map((item) => (
         
              <NavLink
                key={item.name}
                to={item.path}
                end
                onClick={() => {
                  if (onCloseMobile) onCloseMobile();
                }}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-4 rounded-full text-sm font-medium transition-colors ${
                    isActive ? 'bg-white/10 text-white' : 'text-gray-300 hover:bg-white/5'
                  }`
                }
              >
                <span className={`${collapsed?"text-sm":"text-lg"}`}>{item.icon}</span>
                {!collapsed && <span>{item.name}</span>}
              </NavLink>
            ))
          }
        </nav>
      </div>

      {/* Support Ticket Modal */}
      <SupportTicketModal
        isOpen={showSupportModal}
        onClose={() => setShowSupportModal(false)}
      />
    </>
  );
}